import { WorkspaceSizeThresholds } from "@/common/constants";
import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
	summaryContent: {
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Small}px)`]: {
            left: "unset !important",
            right: "16px !important"
		},
	},
});
